type TagSeverity =
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "secondary"
  | undefined;

interface StatusConfig {
  label: string;
  severity: TagSeverity;
  icon: string;
  color?: string;
}

export const printStatusConfig: Record<string, StatusConfig> = {
  default: {
    label: "Unknown",
    severity: "info",
    icon: "pi pi-hourglass",
    color: "#78909c",
  },
  PENDING: {
    label: "Pending",
    severity: "info",
    icon: "pi pi-hourglass",
    color: "#78909c",
  },
  IN_QUEUE: {
    label: "In Queue",
    severity: "warning",
    icon: "pi pi-clock",
    color: "#ffb300",
  },
  PROCESSING: {
    label: "Processing",
    severity: "secondary",
    icon: "pi pi-cog pi-spin",
    color: "#2196f3",
  },
  DONE: {
    label: "Done",
    severity: "success",
    icon: "pi pi-check-circle",
    color: "#4caf50",
  },
  FAILED: {
    label: "Failed",
    severity: "danger",
    icon: "pi pi-times-circle",
    color: "#f44336",
  },
};

export const orderStatusConfig: Record<string, StatusConfig> = {
  PLACED: {
    label: "Placed",
    severity: "success",
    icon: "pi pi-check-circle",
    color: "#4caf50",
  },
  default: {
    label: "Unknown",
    severity: "secondary",
    icon: "pi pi-question-circle",
    color: "#ffc107",
  },
};
